
import Vue from 'vue';
import Tooltip from '../components/tooltip.vue';

export class TooltipLoader {
    private instance: any = null;

    public mount(parent: Vue,target: Element, title: string, placement:string='right'){
        //appの支配下に入れる必要がある
        // const parent: Vue = (document.getElementById('app') as any).__vue__;
        var component = new Tooltip({parent: parent, propsData: {
           target:target, title:title,placement:placement}}).$mount();
        //document.getElementById('app').appendChild(component.$el);
        return component;
    }


}
